import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';

import { MultipleChoice, MCSelectOption } from 'src/app/interfaces/template';

@Component({
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.scss'],
  selector: 'app-multiple-choice',
})
export class MultipleChoiceComponent implements OnInit, OnChanges {

  // group: Listado del select
  @Input() group: MultipleChoice;
  // activate: Evento que comparte la información de la selección
  @Output() activate: EventEmitter<{ [event: string]: Subject<any> }> = new EventEmitter();
  // emiter: Comparte el listado con las opciones
  emiter: Subject<MultipleChoice> = new Subject();
  // selectionEmitter: Comparte la información de la opción seleccionada
  selectionEmitter: Subject<MCSelectOption> = new Subject();
  // select: Seleccionar opciones
  @Input() select: MCSelectOption;

  ngOnInit() { this.activate.emit({ group: this.emiter, selection: this.selectionEmitter }); }

  ngOnChanges(changes: SimpleChanges): void {
    // ↓ Selecciona/Deselecciona una opción
    if (changes.select && changes.select.currentValue) {
      const option: MCSelectOption = changes.select.currentValue;
      this.checkSelection(option.value, option.key, option.type, option.entry);
    }
  }

  /* checkSelection(): Método que muestra/oculta columnas de la tabla
    value: Si está definido se mostrará la columna
    key: Elemento seleccionado
    type: Padre del elemento seleccionado
  */
  checkSelection(value: boolean, key: string, type: string | number, entry: string) {
    // ↓ Verifica si se selcciona la opción de todos
    if (type === 0) {
      // ↓ Itera los índices del grupo
      Object.keys(this.group[key]).forEach((elm: string) => {
        // ↓ Asigna el estado a cada índice
        this.group[key][elm].check = value;
      });
    } else { this.group[type][entry].check = value; }
    // ↑ Asigna el estado al índice
    // ↓ Atualiza la referencia
    this.group = JSON.parse(JSON.stringify(this.group));
    // ↓↓ Comparte la selección
    this.emiter.next(this.group);
    this.selectionEmitter.next({ value, key, type, entry });
  }

}
